// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const versionInfo = {
    "version": "1.0.0",
    "hash": "48befdef",
    "commitDate": "1775605549"
};
/* tslint:enable */
